import {
  UserManagementActions,
  UserManagementActionTypes,
} from './user-management.actions';
import { UserManagementStateInterface } from './user-management.model';


export const UserManagementInitialState: UserManagementStateInterface = {
  page: 1,
  pageCount: 1,
  itemCount: 1,
  itemTotal: 1,
  errors: [],
  filters: null,
  getUsersLoading: false,
  getUsersLoaded: false,
  getUserLoading: false,
  getUserLoaded: false,
  createUserLoading: false,
  createUserCompleted: false,
  updateUserLoading: false,
  updateUserCompleted: false,
  deleteUserLoading: false,
  deleteUserCompleted: false,
  uploadUserLoading: false,
  uploadUserCompleted: false,
  users: [],
  user: null,
};

export function userManagementReducer(state = UserManagementInitialState, action: UserManagementActions): UserManagementStateInterface {
  switch (action.type) {
    case UserManagementActionTypes.GetUsers:
      return {
        ...state,
        getUsersLoading: true,
        getUsersLoaded: false,
      };
    case UserManagementActionTypes.GetUsersCompleted:
      return {
        ...state,
        getUsersLoading: false,
        getUsersLoaded: true,
        users: action.usersList,
        itemTotal: action.itemTotal,
      };

    case UserManagementActionTypes.GetUser:
      return {
        ...state,
        getUserLoading: true,
        getUserLoaded: false,
      };
    case UserManagementActionTypes.GetUserCompleted:
      return {
        ...state,
        getUserLoading: false,
        getUserLoaded: true,
        user: action.user.data,
      };
    case UserManagementActionTypes.CreateUser:
      return {
        ...state,
        createUserLoading: true,
        createUserCompleted: false,
      };
    case UserManagementActionTypes.CreateUserCompleted:
      return {
        ...state,
        createUserLoading: false,
        createUserCompleted: true,
      };
    case UserManagementActionTypes.UpdateUser:
      return {
        ...state,
        updateUserLoading: true,
        updateUserCompleted: false,
      };
    case UserManagementActionTypes.UpdateUserCompleted:
      return {
        ...state,
        updateUserLoading: false,
        updateUserCompleted: true,
      };

    case UserManagementActionTypes.DeleteUser:
      return {
        ...state,
        deleteUserLoading: true,
        deleteUserCompleted: false,
      };
    case UserManagementActionTypes.DeleteUserCompleted:
      return {
        ...state,
        deleteUserLoading: false,
        deleteUserCompleted: true,
      };

    case UserManagementActionTypes.UploadUser:
      return {
        ...state,
        uploadUserLoading: true,
        uploadUserCompleted: false,
      };
    case UserManagementActionTypes.UploadUserCompleted:
      return {
        ...state,
        uploadUserLoading: false,
        uploadUserCompleted: true,
      };

    case UserManagementActionTypes.ClearState:
      return { ...UserManagementInitialState };

    case UserManagementActionTypes.FetchError:
      return {
        ...state,
        errors: action.payload,
      };

    default:
      return state;
  }
}
